<div
  (click)="previewHandlerService.checkPreviewVisibility($event); $event.stopPropagation()"
  class="results-wrapper"
  [class.preview-mode]="isPreviewMode"
>
  <preview-results
    [resultsTemplate]="resultsTemplate"
    [smallView]="smallView"
    [scrollHeight]="scrollHeight"
    [displayedContext]="displayedContext"
    [searchId]="searchId"
    [previewHeight]="previewHeight"
    [selectedIndex]="selectedIndex"
    [isPreviewMode]="isPreviewMode"
    [previewWidth]="previewHandlerService.previewViewModel.previewWidth"
    [maxPreviewWidth]="previewHandlerService.splitAreaPreviewModel.maxPreviewWidth"
    [minPreviewWidth]="previewHandlerService.splitAreaPreviewModel.minPreviewWidth"
    [visiblePreview]="previewHandlerService.splitAreaPreviewModel.visiblePreview"
    [visibleResults]="previewHandlerService.splitAreaPreviewModel.visibleResults"
    [hiddenPreview]="hiddenPreview || tree?.length === 0"
    [previewType]="previewHandlerService.selected?.action?.type"
    [previewViewModel]="previewHandlerService.previewViewModel"
    [selected]="previewHandlerService.selected$ | async"
    (invoke)="onInvoke($event, 'result')"
    (invokeDirty)="onInvokeDirty($event)"
    (previewDragEnd)="updateResultsWidthAndGridColumns()"
    (sizeChanged)="previewHandlerService.updatePreviewState($event)"
  ></preview-results>
</div>

<ng-template #resultsTemplate>
  <div
    #resultsSplitArea
    #contextContainer
    class="results-container"
    [ngClass]="{ border: tree?.length !== 0 && previewHandlerService.previewViewModel.previewState === 'side' }"
  >
    <u-tree
      #utree
      id="utree"
      class="tree-container"
      [value]="tree"
      [scrollHeight]="scrollHeight"
      [selection]="selectedNodes"
      [selectionMode]="canEdit ? 'checkbox' : null"
      [nodeTemplate]="nodeTemplate"
      [emptyTemplate]="emptyTemplate"
      [dragAndDrop]="!isSearchState && canEdit && !isNative"
      [dragAndDropScope]="'self'"
      [validateDrop]="validateDrop"
      (onDrag)="changeFocus('card-drag')"
      (onNodeDrop)="nodeDrop($event)"
      (onCancelDrop)="onCancelDrop()"
      (selectionChange)="selectionChange($event)"
    >
    </u-tree>
  </div>
</ng-template>

<ng-template #nodeTemplate let-node>
  <ng-container *ngIf="node.data.type === 'result'">
    <ng-container *ngTemplateOutlet="resultTemplate; context: { result: node.data, i: node.data.resultIndex }"></ng-container>
  </ng-container>
  <ng-container *ngIf="node.data.type === 'folder'">
    <ng-container *ngTemplateOutlet="folderTemplate; context: { folder: node.data, i: node.data.resultIndex, node }"></ng-container>
  </ng-container>
</ng-template>

<ng-template #emptyTemplate>
  <div class="no-results" *ngIf="emptyResults">
    <h1 class="no-results-title headline-1">{{ emptyResultsText }}</h1>
    <q class="headline-1 bold" *ngIf="query">
      {{ query | truncate: 30 }}
    </q>
  </div>
</ng-template>

<ng-template #resultTemplate let-result="result" let-i="i">
  <result-item
    #resultItem
    [class.disabled]="result.deleted"
    [class.selected]="selectedIndex === i"
    [class.hovered]="!dragInprogress && hoveredIndex === i"
    [class.keyboardOn]="keyboardOn"
    [class.preview-mode]="previewHandlerService.previewViewModel.previewState === 'side'"
    [class.summary]="onOpenSummaryPopup"
    [class.isCard]="true"
    [previewState]="previewHandlerService.previewViewModel.previewState"
    [previewable]="isPreviewClickAction(result.action)"
    [sessionId]="displayedContext?.sessionId"
    [summaryResourceId]="result.resourceId"
    [clientSearchId]="displayedContext?.clientSearchId"
    [contextMenu]="contextMenu"
    [selected]="selectedIndex === i"
    tabindex="0"
    [index]="i"
    [resultsIndex]="result.resultIndex"
    class="tree-result-item"
    (invoke)="setSelected(i, result, $event); onInvoke($event, 'result')"
    (click)="setSelected(i, result); $event.stopPropagation()"
    [attr.data-index]="i"
    [listName]="listName"
    [model]="getModel(result)"
    (contextOpen)="openContextMenu(i, result)"
    (contextClose)="closeContextMenu()"
    (mouseover)="hoveredIndex = i"
    (mouseout)="!onOpenContextMenu && !onOpenSummaryPopup ? (hoveredIndex = null) : null"
    [hovered]="hoveredIndex === i"
    (titleChanged)="onTitleChanged($event, result, i)"
    [pageType]="pageType"
    [showResultSections]="getShowResultSections(result) || { calcBullets: !!result.resource }"
    [resultsWidth]="resultsRef?.nativeElement?.offsetWidth"
    [layoutMode]="'list'"
  >
  </result-item>
</ng-template>

<ng-template #folderTemplate let-folder="folder" let-i="i" let-node="node">
  <result-folder
    class="tree-folder-item"
    [model]="getModel(folder)"
    [showInputTitle]="showInputTitleIndex === i"
    [inputPlaceholder]="'Folder'"
    [defaultInputModel]="'Folder'"
    [descriptionTextCount]="'Cards'"
    [class.selected]="selectedIndex === i"
    [attr.data-index]="i"
    [canEdit]="canEdit"
    (titleChanged)="onTitleChanged($event, folder, i)"
    (mouseover)="hoveredIndex = i"
    (mouseout)="!onOpenContextMenu && !onOpenSummaryPopup ? (hoveredIndex = null) : null"
    (contextOpen)="openContextMenu(i, result)"
    (contextClose)="closeContextMenu()"
    (onBlur)="showInputTitleIndex = null"
    (invoke)="setSelected(i, folder, $event); onInvoke($event, 'folder')"
    (click)="setSelected(i, folder); openFolder(i, node); $event.stopPropagation()"
  ></result-folder>
</ng-template>
